var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"active":_vm.shown,"has-modal-card":"","trap-focus":"","destroy-on-hide":false,"aria-role":"dialog","aria-modal":""},on:{"update:active":_vm.onShownChange}},[_c(_vm.component,{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }